import { PresetsPage } from "@/pages/presets/PresetsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/presets")({
  component: PresetsPage,
});
